import { useProfileContext } from 'hooks/context/useProfileContext'
import React, { createContext, useMemo, useState } from 'react'

interface TwoFAProps {
  twoFactorEnabled: boolean
  showTwoFAModal: boolean
  setShowTwoFAModal: React.Dispatch<React.SetStateAction<boolean>>
}

export const TwoFAContext = createContext<TwoFAProps>(null)

export const TwoFAProvider = ({ children, enable2FAModal = false }) => {
  const { profile } = useProfileContext()
  const twoFactorEnabled = profile?.twoFactorEnabled
  const [showTwoFAModal, setShowTwoFAModal] = useState(enable2FAModal || false)
  const value = useMemo(
    () => ({
      twoFactorEnabled,
      showTwoFAModal,
      setShowTwoFAModal,
    }),
    [twoFactorEnabled, showTwoFAModal, setShowTwoFAModal]
  )

  return <TwoFAContext.Provider value={value}>{children}</TwoFAContext.Provider>
}
